/* KIRIBAN contact pop-up. Opens from any link to #contact (or [data-kb-contact]). The Shopify contact form is sent
   normally (so Shopify's spam check works); after the page reloads, the visitor is put back where they were and the
   pop-up reopens showing "Message sent". Messages go to the store's contact email. */
(function () {
  "use strict";
  var box = document.getElementById("kbx"), form = document.getElementById("kbx-form");
  if (!box || !form) return;
  var err = box.querySelector(".kbx-err"), btn = form.querySelector("button[type=submit]"), last = null;
  function open(e) {
    if (e) e.preventDefault();
    last = document.activeElement;
    box.hidden = false; document.body.classList.add("kbx-open");
    requestAnimationFrame(function () { box.classList.add("on"); });
    var fine = matchMedia("(hover: hover) and (pointer: fine)").matches;   // no keyboard pop-up on phones
    setTimeout(function () { var f = box.querySelector(box.classList.contains("sent") || !fine ? ".kbx-x" : "input[name='contact[name]']"); if (f) f.focus({ preventScroll: true }); box.querySelector(".kbx-box").scrollTop = 0; }, 60);
    if (location.hash === "#contact") history.replaceState(null, "", location.pathname + location.search);
  }
  function close() {
    box.classList.remove("on"); document.body.classList.remove("kbx-open");
    setTimeout(function () { box.hidden = true; if (box.classList.contains("sent")) { box.classList.remove("sent"); form.reset(); } }, 300);
    if (last && last.focus) last.focus({ preventScroll: true });
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest("a[href$='#contact'],[data-kb-contact]");
    if (a) open(e);
  });
  box.addEventListener("click", function (e) { if (e.target === box || e.target.closest("[data-kbx-close]")) close(); });
  document.addEventListener("keydown", function (e) {
    if (box.hidden) return;
    if (e.key === "Escape") close();
    if (e.key === "Tab") {                                     // keep focus inside the pop-up
      var f = [].slice.call(box.querySelectorAll("a[href],button,input,select,textarea")).filter(function (n) { return n.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  form.addEventListener("submit", function (e) {
    err.textContent = "";
    var em = form.querySelector("input[type=email]");
    if (!em.value || em.value.indexOf("@") < 1) { e.preventDefault(); err.textContent = "Please enter a valid email address."; em.focus(); return; }
    // Normal submit, so Shopify's spam check runs. Remember where the visitor was; after the reload the pop-up reopens as "sent".
    try { sessionStorage.setItem("kbx-y", String(scrollY)); } catch (er) {}
    btn.textContent = "Sending…";
  });
  if (form.querySelector("[data-kbx-posted]")) {
    var y = null; try { y = sessionStorage.getItem("kbx-y"); sessionStorage.removeItem("kbx-y"); } catch (er) {}
    if (y) scrollTo({ top: +y, behavior: "instant" });
    box.classList.add("sent"); open();
  } else if (form.querySelector("[data-kbx-failed]")) { err.textContent = box.getAttribute("data-err"); open(); }
  else if (location.hash === "#contact") open();
})();
